import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import CommunicationError from 'components/customer/communication_error';
import ConversationItem from 'models/conversation_item';

// `message` is translated by the caller, per the repo convention for label
// props. The fallback below belongs to this component, so it is translated here.
export default function ItemCommError({ className, item, message, onClick }) {
  const { t } = useTranslation();
  if (!item.content.hasErrorStatus()) {
    return null;
  }

  let classNames = classnames('conversationItem-communicationError', className);

  return (
    <CommunicationError
      className={classNames}
      helpDocHref={(item.content.getErrorMessageHelpDocHref && item.content.getErrorMessageHelpDocHref()) || ''}
      message={
        message || (item.content.getErrorMessage && item.content.getErrorMessage()) || t('An unknown error occurred.')
      }
      onClick={onClick}
    />
  );
}

ItemCommError.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  message: PropTypes.string,
  onClick: PropTypes.func,
};
